"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
var AbuseReportSubjectTypeEnum;
(function (AbuseReportSubjectTypeEnum) {
    AbuseReportSubjectTypeEnum["POST"] = "post";
})(AbuseReportSubjectTypeEnum = exports.AbuseReportSubjectTypeEnum || (exports.AbuseReportSubjectTypeEnum = {}));
var AbuseReportReasonType;
(function (AbuseReportReasonType) {
    AbuseReportReasonType["INAPPROPRIATE_CONTENT"] = "inappropriate_content";
    AbuseReportReasonType["SPAM"] = "spam";
})(AbuseReportReasonType = exports.AbuseReportReasonType || (exports.AbuseReportReasonType = {}));
class AbuseProvider extends DataProvider_1.default {
    create({ data }) {
        return this.mutate("abuseReportCreate", { data });
    }
}
exports.AbuseProvider = AbuseProvider;
//# sourceMappingURL=AbuseProvider.js.map